import type { WidgetLocale } from '../../types/widgetLocale';

import { getIntlLocale } from '../getIntlLocale';
import { getWidgetMessages } from '../getWidgetMessages';

/**
 * По переданной дате возвращает строку в виде «сегодня» или «вчера»,
 * либо число и месяц в локали виджета.
 */
export const getDateLiteral = (date: string, locale: WidgetLocale) => {
  const { dates } = getWidgetMessages(locale);
  const dateObject = new Date(date);

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (dateObject.toDateString() === today.toDateString()) {
    return dates.today;
  }
  if (dateObject.toDateString() === yesterday.toDateString()) {
    return dates.yesterday;
  }

  return dateObject.toLocaleDateString(getIntlLocale(locale), {
    day: 'numeric',
    month: 'long',
  });
};
